// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6fede5bd","453":"9fb933da"}[chunkId] + ".chunk.js";
};